import { Injectable } from '@angular/core';
import { gql, Mutation } from 'apollo-angular';

import { Mutation as RootMutation } from 'graphql/models/generated';

export const UPDATE_OFFER_COMMISSION_MUTATION = gql`
mutation updateOfferCommission($documentVersion: DocumentVersionInput!, $commission: String!) {
  quotes {
    modify(documentVersion: $documentVersion) {
      setCustomPropertyValue(key: "Commission", stringValue: $commission) { id }
    }
  }
}
`;

@Injectable({
  providedIn: 'root'
})
export class UpdateOfferCommissionMutation extends Mutation<RootMutation> {
  document = UPDATE_OFFER_COMMISSION_MUTATION;
}
